<template>
  <ag-modal-container
    title="Modification d'un document"
    width="800px"
    @close="back"
  >
    <document-form
      v-if="value"
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="primary"
        class="ml-5"
        @click="update"
        v-text="'Modifier'"
      />
      <v-spacer />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import DocumentForm from '../components/DocumentForm'

export default {
  name: 'DocumentUpdateContainer',
  components: {
    AgModalContainer,
    DocumentForm,
  },
  props: {
    documentId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: null,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.document.get(this.documentId)
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async update () {
      this.loading = true
      try {
        await Repositories.document.patch({ ...this.value, ...{ isFormData: true } })
        this.showSuccessNotification(`La modification de ${this.value.name} est validé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
